import { Header } from 'antd/es/layout/layout'
import { AppLogo } from '../Header/AppLogo'
import { LeftAppNav, RightAppNav } from '../../pages/Editor/AppNav'

export const Navigation = () => {
  return (
    <Header className="flex items-center gap-4 bg-white border-b px-6 md:px-12">
      <AppLogo />
      <LeftAppNav />
      <div className="flex-1" />
      <RightAppNav />
    </Header>
  )
}
